(() => {
  var modal = document.getElementById("simpleModal");
  var closeBtn = document.getElementById("closeModalBtn");

  if(!modal || !closeBtn) return;
  
  closeBtn.addEventListener("click", closeModal);
  
  function closeModal() {
    modal.style.display = "none";
  }
  
  window.addEventListener("click", clickOutside);
  
  function clickOutside(e) {
    if (e.target == modal) {
      modal.style.display = "none";
    }
  }
  
  if (!("ss360Configs" in window)) {
    window.ss360Configs = {};
  }
  
  window.ss360Configs.SS360_Gallery = {
    siteId: "sx_live_6244",
    searchBox: {
      selector: "#searchBox",
      placeholder: "Category",
    },
    suggestions: {
      show: true,
      showImages: true,
    },
    results: {
      searchQueryParamName : "gs",
      embedConfig: {
        //			    contentBlock: ".customer-gallery__galleryImage"
        contentBlock: "#results",
      },
      resultTemplate: {
        template: `  <div>
      <div class="customer-gallery__gallery-header">
        <img
          src="{{dataPointHash.logoimage[0]}}"
          alt="{{ name }}"
          class="customer-gallery__headerLogo"
        />
        <h3 class="customer-gallery__headerTitle">{{name}}</h3>
      </div>
      <div class="customer-gallery__galleryImage">
        <img
          src="{{ image }}"
          alt="{{ name }}"
          class="customer-gallery__galeryImage-img"
        />
        <div class="customer-gallery__galleryHover">
          <ul class="customer-gallery__hoverText">
            <li class="customer-gallery__home">
              <h3 class="customer-gallery__hoverTextHeader">
                Platform
              </h3>
              <p class="customer-gallery__hoverTextP" id="platform">
                {{ dataPointHash.platform[0] }}
              </p>
            </li>
            <li class="customer-gallery__star">
              <h3 class="customer-gallery__hoverTextHeader">
                Features
              </h3>
              <p class="customer-gallery__hoverTextP" id="features">
                {{ dataPointHash.features[0] }}
              </p>
            </li>
            <li class="customer-gallery__support">
              <h3 class="customer-gallery__hoverTextHeader">
                Implementation
              </h3>
              <p class="customer-gallery__hoverTextP" id="implementation">
                {{ dataPointHash.implementation[0] }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="customer-gallery__tagsSection">
            <div class="customer-gallery__category">
                {{ dataPointHash.category[0] }}        
            </div>
            <div class="customer-gallery__subCategory">
                {{ dataPointHash.subcategory[0] }}
            </div>
            <div class="customer-gallery__expandButton">
            <img class="customer-gallery__expandImage" src="https://cdn.sitesearch360.com/customer_gallery/icons/expand_arrows.png" alt="">
            </div>
          </div>    
    </div>`,
        // preRenderCallback(suggest) {
        // },
        postRenderCallback(node, suggest) {
          node.find(".customer-gallery__galleryImage").on("click", () => {
            document.getElementById("platform-detail").innerText =
              suggest.dataPointHash.platform[0];
            document.getElementById("implementation-detail").innerText =
              suggest.dataPointHash.implementation[0];
            document.getElementById("features-detail").innerText =
              suggest.dataPointHash.features[0];
            document.getElementById("detail-image").src =
              suggest.dataPointHash.image[0];
            document.getElementById("detail-logo").src =
              suggest.dataPointHash.logoimage[0];
            document.getElementById("detail-company-url").href = suggest.link;
            document.getElementById("detail-company-url").innerText =
              suggest.name;
            modal.style.display = "block";
          });
          node.find(".customer-gallery__expandButton").on("click", () => {
            document.getElementById("platform-detail").innerText =
              suggest.dataPointHash.platform[0];
            document.getElementById("implementation-detail").innerText =
              suggest.dataPointHash.implementation[0];
            document.getElementById("features-detail").innerText =
              suggest.dataPointHash.features[0];
            document.getElementById("detail-image").src =
              suggest.dataPointHash.image[0];
            document.getElementById("detail-logo").src =
              suggest.dataPointHash.logoimage[0];
            document.getElementById("detail-company-url").href = suggest.link;
            document.getElementById("detail-company-url").innerText =
              suggest.name;
            modal.style.display = "block";
          });
        },
      },
    },
    layout: {
      desktop: {
        type: "grid",
        gridColsXl: 2,
        gridColsLg: 2,
      },
      // masonryCols: {
      //   // how many masonry grid columns to show, minimum width to column count mapping (default: 2 columns below 768px, 3 columns between 768px and 991px, 5 columns between 992px and 1199px and 6 columns above 1200px)
      //   0: 2,
      //   768: 2,
      //   992: 2,
      //   1200: 2,
      // },
    },
    callbacks: {
      init() {
        window.SS360_Gallery.showResults("*", {
          shouldPushState: false
        });
      },
    },
    filters: {
      enabled: true,
      position: "top"
    }
  };
})();
